import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import CardContainer from "../../../../commons/components/cardContainer"
import AccountButtonBack from "../../../../commons/components/AccountButtonBack";
import ButtonAction from "../../../../commons/components/buttonAction";
import UserIcon from "../../../../commons/icons/userIcon";
import Utils from "../../../../commons/utils/utils";
import Loading from "../../../../commons/components/loading";

import {
    usersSetMainEmailModal,
    usersSetMainEmailShowModal,
    usersSetMainEmailSelectedUser,
    usersSetShowUsers,
    usersSetShowEditUser,
    usersSetSelectedUser,
    usersSetSearchPartner,
} from '../../../../store/actions/usersActions';

import { RowData, ColData, DivPhoto, DivField, DivFieldLabel, DivFieldValue } from './cardDataUserStyles';
import ChangeEmailModal from "../ChangeEmailModal/changeEmailModal";

import Permissions from "../../../../commons/utils/permissions";
import changeEmailModalModes from "../ChangeEmailModal/changeEmailModalModes";

function CardDataUser(props) {
    const { selectedUser, showMainEmailUserModal, mainEmailSelectedUser } = useSelector((state) => state.users);
    const dispatch = useDispatch();

    const { screens } = useSelector(state => state.userLogin);
    const [permissions] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/users") {
                    screen.functions.map(_function => {
                        if (!permissions.find(permission => permission.function_id == _function.function_id)) {
                            permissions.push(_function);
                        }
                    })
                }
            });
        }
        
        setLoading(false);
    }, [screens]);

    function handleBack() {
        dispatch(usersSetShowEditUser(false));
        dispatch(usersSetShowUsers(true));
        dispatch(usersSetSelectedUser({}));
        dispatch(usersSetSearchPartner(""));
        
        setLoading(false);
    }

    function handleEditUser(user) {
        dispatch(usersSetMainEmailModal(changeEmailModalModes.EDIT));
        dispatch(usersSetMainEmailShowModal(true));
        dispatch(usersSetMainEmailSelectedUser(user));
    };

    function handleOnSave() {
        usersSetSelectedUser(mainEmailSelectedUser)
    }

    function showEditUser() {
        const haveEditUserPermissions = permissions.find(_function => _function.function_id === Permissions.EDITAR_EMAIL_PRINCIPAL);

        if (haveEditUserPermissions){
            return true;
        }

        return false;
    }

    return (
        <>
        {loading ?
            <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                <Loading width={50} height={50} />
            </div> 
            :
            <>
                <AccountButtonBack
                    label="Voltar"
                    onClick={handleBack}
                />
                    <CardContainer style={{ minHeight: 100 }}>
                        <RowData align={"top"}>
                            <ColData>
                                <DivPhoto>
                                    {selectedUser.picture ? <img src={selectedUser.picture} /> : <UserIcon style={{ height: 28, width: 28 }} />}
                                </DivPhoto>
                            </ColData>
                            <ColData flex="auto">
                                <Row>
                                    <Col flex="200px">
                                        <DivField>
                                            <DivFieldLabel>{"Nome:"}</DivFieldLabel>
                                            <DivFieldValue>{selectedUser.name}</DivFieldValue>
                                        </DivField>
                                        <DivField>
                                            <DivFieldLabel>{"CPF:"}</DivFieldLabel>
                                            <DivFieldValue>{Utils.maskCpf(selectedUser.identification_number)}</DivFieldValue>
                                        </DivField>
                                        <DivField>
                                            <DivFieldLabel>{"Telefone:"}</DivFieldLabel>
                                            <DivFieldValue>{selectedUser.phone}</DivFieldValue>
                                        </DivField>
                                    </Col>
                                    <Col flex="200px">
                                        <DivField>
                                            <DivFieldLabel>{"Desenvolvedor Sankhya:"}</DivFieldLabel>
                                            <DivFieldValue>{selectedUser.developer ? "Sim" : "Não"}</DivFieldValue>
                                        </DivField>
                                        <DivField>
                                            <DivFieldLabel>{"E-mail:"}</DivFieldLabel>
                                            <DivFieldValue>{selectedUser.emails.map((item, index) => (<div key={index}>{item}</div>))}</DivFieldValue>
                                            
                                            { showEditUser() ?
                                            <ButtonAction type="edit" text="Editar email principal" callback={() => handleEditUser(selectedUser)} />
                                            : null
                                            }

                                        </DivField>
                                    </Col>
                                </Row>
                            </ColData>
                        </RowData>
                    </CardContainer>

                {showMainEmailUserModal ? <ChangeEmailModal onSave={handleOnSave} /> : null}
            </>
        }
        </>
    )
}

export default CardDataUser;
